import { ErrorHandler, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ApiModule, Configuration } from '@gcv/generated-services';
import { AmplifyAngularModule, AmplifyService } from 'aws-amplify-angular';
import { HttpClient, HttpHandler, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Config, parseGcvConfig } from '../services/config';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CustomErrorHandler } from '../services/customErrorHandler.service';
import { httpClientFactory } from '../services/customHttpClient/httpClientFactory';
import { RollbarService } from '../services/rollbar/rollbar.service';
import { rollbarFactory } from '../services/rollbar/rollbar.config';
import { GcvCommonModule } from '../components/common.module';
import { Angulartics2Module } from 'angulartics2';
import { StateModule } from '@user-interface/gcv-state';
import { TermsOfServiceModule } from './terms-of-service/terms-of-service.module';
import { SupportUserLoginModule } from './support-user-login/support-user-login.module';
import { ServerErrorInterceptor } from '../services/service-error.interceptor';

export const angulartics2Settings = {
  pageTracking: {
    clearIds: true,
    clearHash: true,
    clearQueryParams: true,
  },
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    AmplifyAngularModule,
    ApiModule.forRoot(getApiConfig),
    BrowserAnimationsModule,
    TermsOfServiceModule,
    SupportUserLoginModule,
    AppRoutingModule,
    GcvCommonModule,
    BrowserModule,
    HttpClientModule,
    StateModule,
    Angulartics2Module.forRoot(angulartics2Settings),
  ],
  providers: [
    AmplifyService,
    { provide: Config, useValue: parseGcvConfig(environment) },
    { provide: ErrorHandler, useClass: CustomErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: ServerErrorInterceptor, multi: true },
    { provide: RollbarService, useFactory: rollbarFactory },
    { provide: HttpClient, useFactory: httpClientFactory, deps: [HttpHandler] },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

const apiConfig = new Configuration({
  withCredentials: false,
  apiKeys: {}, // TODO look into setting all headers here instead of
  ...(environment.basePath
    ? {
        basePath: environment.basePath,
      }
    : {}),
});

export function getApiConfig() {
  return apiConfig;
}

export { apiConfig };
